import PropTypes from "prop-types";
import { Accordion } from "react-bootstrap";
import Spinner from "../../components/ui/Spinner";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faCircleXmark } from "@fortawesome/free-solid-svg-icons";

export const ModalEnviarSAP = (props) => {
  const { arr, actual, hideModal, cont } = props;

  const rtnText = (obj) => {
    return "Cambio de status exitoso";
  };

  return (
    <>
      <Accordion defaultActiveKey="0" className="pb-3">
        {arr.map((el, idx) => {
          return (
            <Accordion.Item eventKey={idx} key={(`${el.persona.nombre}${el.persona.apellido_pat}`).replaceAll(" ","")}>
              <Accordion.Header>
                <div className="d-flex w-100 pe-3">
                  <FontAwesomeIcon
                    size="xl"
                    icon={[200].includes(el.resp.status) && el.resp.data.status !== "error" ? faCheckCircle : faCircleXmark}
                    className={`text-${[200].includes(el.resp.status) && el.resp.data.status !== "error" ? "success" : "danger"}`}
                  />
                  <span className="ms-3">
                    {el.persona.nombre} {el.persona.apellido_pat}
                  </span>
                </div>
              </Accordion.Header>
              <Accordion.Body className="px-2 pb-1">
                <pre style={{ fontSize: "14px", lineHeight: "17px" }}>
                  {el.resp.data.status === "error" ? JSON.stringify(el.resp.data, null, 2) : rtnText(el)}
                </pre>
              </Accordion.Body>
            </Accordion.Item>
          );
        })}
      </Accordion>
      {actual ? (
        <div
          className="alert alert-primary d-flex justify-content-between ps-2 pe-0 text-dark align-items-center"
          role="alert"
          style={{ height: "59px" }}
        >
          <div>
            <b className="me-2">{`${arr.length + 1} de ${cont}`}:</b>
            {actual.persona.nombre} {actual.persona.apellido_pat} / {actual.persona.id_sap}
          </div>
          <div>
            <Spinner />
          </div>
        </div>
      ) : (
        <div className="d-flex justify-content-center mb-3">
          <button
            onClick={() => {
              hideModal();
            }}
            className="btnCopec px-4"
          >
            Proceso culminado
          </button>
        </div>
      )}
    </>
  );
};

ModalEnviarSAP.propTypes = {
  arr: PropTypes.array.isRequired,
  actual: PropTypes.object,
  hideModal: PropTypes.func.isRequired,
  cont: PropTypes.number.isRequired,
};
